import { useLiveRef } from 'base/useLiveRef';
import { useCallback } from 'react';

export function useStableCallback<T extends (...args: any[]) => any>(
  callback: T,
): T {
  const callbackRef = useLiveRef(callback);

  return useCallback(
    (...args: Parameters<T>) => {
      return callbackRef.current(...args);
    },
    [callbackRef],
  ) as T;
}
